var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "mod_actpop"
  }, [_c('div', {
    staticClass: "img_area"
  }, [_c('img', {
    attrs: {
      "src": "https://puui.qpic.cn/vupload/0/20190410_1554888118231_kf27uduv3gs.png/0"
    }
  })]), _c('div', {
    staticClass: "close"
  })])]);
}];
export { render, staticRenderFns };